define("shared/components/shared/profile-categorization/rewards-steps/report/partial", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="u--m__b__xs u--text--light u--text--center">
    {{t (concat @prefix "industry_insights")}}
  </p>
  
  <a class="u--block u--text--center qa--categorize_back" {{on "click" (fn @clearSelectedCategory "rewards")}}>
    {{t "profile_categorization.categorize_form.change_selection"}}
  </a>
  
  <h2 class="tSC--card__title u--text--center">
    {{t (concat "profile_categorization.industries." @socialProfile.industry)}}
  </h2>
  
  <div class="tSC--result">
    <Shared::ProfileCategorization::RewardsSteps::Tab::HashtagUsage
      @industryHashtags={{@industryReportData.industryHashtags}}
      @isLoading={{@industryReportData.isLoading}}
      @sectionName={{@sectionName}}
      @showPartialRewards={{true}}
      @socialProfile={{@socialProfile}}
      @triggerSegmentEvent={{fn this.trackViewedIndustryComparison 2}}
    />
  </div>
  
  <Shared::Ui::Button
    @additional="block"
    @onClick={{fn @exitCategorization false}}
    @size="regular"
    class="qa--categorize_reports_exit"
  >
    {{#if @isModalFlow}}
      {{t "shared_words.done"}}
    {{else}}
      {{t "authorization.sign_up_success.finish_setup"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "lyVLDV7W",
    "block": "[[[10,2],[14,0,\"u--m__b__xs u--text--light u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[[30,1],\"industry_insights\"],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[11,3],[24,0,\"u--block u--text--center qa--categorize_back\"],[4,[38,2],[\"click\",[28,[37,3],[[30,2],\"rewards\"],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"profile_categorization.categorize_form.change_selection\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"h2\"],[14,0,\"tSC--card__title u--text--center\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[[28,[37,1],[\"profile_categorization.industries.\",[30,3,[\"industry\"]]],null]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"tSC--result\"],[12],[1,\"\\n  \"],[8,[39,4],null,[[\"@industryHashtags\",\"@isLoading\",\"@sectionName\",\"@showPartialRewards\",\"@socialProfile\",\"@triggerSegmentEvent\"],[[30,4,[\"industryHashtags\"]],[30,4,[\"isLoading\"]],[30,5],true,[30,3],[28,[37,3],[[30,0,[\"trackViewedIndustryComparison\"]],2],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,5],[[24,0,\"qa--categorize_reports_exit\"]],[[\"@additional\",\"@onClick\",\"@size\"],[\"block\",[28,[37,3],[[30,6],false],null],\"regular\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,7],[[[1,\"    \"],[1,[28,[35,0],[\"shared_words.done\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,0],[\"authorization.sign_up_success.finish_setup\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@prefix\",\"@clearSelectedCategory\",\"@socialProfile\",\"@industryReportData\",\"@sectionName\",\"@exitCategorization\",\"@isModalFlow\"],false,[\"t\",\"concat\",\"on\",\"fn\",\"shared/profile-categorization/rewards-steps/tab/hashtag-usage\",\"shared/ui/button\",\"if\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report/partial.hbs",
    "isStrictMode": false
  });
  let PartialComponent = _exports.default = (_class = class PartialComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "segment", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
    }
    trackViewedIndustryComparison(tabNum) {
      try {
        this.segment.track('viewed-industry-comparison-self-cat', {
          area: this.args.sectionName,
          user: this.auth.currentUserModel.id,
          profile: this.args.socialProfile.id,
          is_business: this.args.socialProfile.isBusiness,
          category: this.args.socialProfile.category,
          industry: this.args.socialProfile.industry,
          bus_model: this.args.socialProfile.businessModel,
          tab: tabNum === 1 ? 'engagement' : 'hashtags',
          social_profile_nickname: this.args.socialProfile.nickname
        });
      } catch (error) {
        this.errors.log(new Error(`Error Tracking viewed-industry-comparison-self-cat from location ${this.args.sectionName}`), error);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackViewedIndustryComparison", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackViewedIndustryComparison"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PartialComponent);
});